import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data,
    headers: {
      'user-type': data.userType
    }
  })
}

// 退出
export function logout(config) {
  return request({
    url: `/logout`,
    method: 'get', config
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/sys/user/info',
    method: 'get'
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/sys/user/update',
    method: 'put',
    data
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/sys/user/update/pwd',
    method: 'put',
    data
  })
}

// 多条件分页查询系统管理员
export function getUserList(params) {
  return request({
    url: '/sys/user/page',
    method: 'get',
    params: {
      ...params,
      current: params.page  // 确保分页参数名称正确
    }
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/sys/user/save',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(data) {
  return request({
    url: '/sys/user/update',
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/sys/user/delete/${id}`,
    method: 'delete'
  })
}


//更改用户状态
export function setUserStatus(id) {
  return request({
    url: `/sys/user/updateStatus/${id}`,
    method: 'put'
  })
}

// 获取角色列表
export function getRoleList() {
  return request({
    url: '/sys/role/list',
    method: 'get'
  })
}

//获取导航菜单,会根据角色不同给的菜单不同
export function getMenuNav() {
  return request({
    url: '/sys/menu/nav',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 检查用户名是否存在
export function checkUsername(username) {
  return request({
    url: `/sys/user/exists/${username}`,
    method: 'get'
  })
}

//根据ID标识查询系统管理员信息
export function getUserById(id) {
  return request({
    url: `/sys/user/info/${id}`,
    method: 'get'
  })
}

// 密码验证
export function pwdVerfity(data) {
  return request({
    url: '/sys/user/pwdVerfity',
    method: 'post',
    data
  })
}